import * as React from "react";
import supabase from "@clients/supabase";
import { useStaticQuery, graphql } from "gatsby";
import { useAuth } from "@store/auth";
import { invoke } from "@kalabo/golfsavers-common";

const useUser = () => {
  const userToken = useAuth((state) => state.userToken);
  const [loading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState(null);
  const [authUser, setAuthUser] = React.useState(null);

  const data = useStaticQuery(graphql`
    query {
      allGolfsaversCurrencies(sort: { name: DESC }) {
        edges {
          node {
            name
            id
            symbol
            code
          }
        }
      }
    }
  `);

  let currencies = data.allGolfsaversCurrencies.edges;

  React.useEffect(() => {
    supabase.auth.onAuthStateChange(async (event, session) => {
      setLoading(true);
    });
  }, []);

  React.useEffect(() => {
    if (!loading) return;

    if (!userToken) return;
    const fetchData = async () => {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();
      if (error) return;
      getUser(user?.id);
      setAuthUser(user);
      setLoading(false);
    };

    fetchData();
  }, [loading, userToken]);

  const updateUser = React.useCallback(() => {}, [authUser]);

  const setDisplayCurrency = React.useCallback(
    async (currency: string) => {
      const { data, error } = await supabase
        .from("user_profiles")
        .update({
          display_currency: currency,
        })
        .eq("id", authUser?.id);

      await getUser(authUser?.id);
    },
    [authUser]
  );

  const getDisplayCurrency = React.useCallback(() => {
    // get the user's currency from the currencies list
    let currency = currencies?.find(
      (c: any) => c.node.code === (user?.display_currency || "THB")
    );

    if (!currency) return null;

    return currency.node;
  }, [user]);

  const getActiveBookings = React.useCallback(async () => {
    let response = await invoke("getCustomerOrders", {
      userId: authUser?.id,
    });
    if (response.status !== 200) return;
    let data = response.body;

    return data;
  }, [authUser]);

  const getUser = React.useCallback(
    async (id?: string) => {
      let uid = id || authUser?.id;

      if (!uid) return;
      const { data, error } = await supabase
        .from("user_profiles")
        .select(
          `id, first_name, last_name, phone, user_favourites, display_currency, country_of_residence, email, created_at`
        )
        .eq("id", uid)
        .single();
      setUser(data);
    },
    [authUser]
  );

  return {
    user,
    authUser,
    updateUser,
    getUser,
    getDisplayCurrency,
    getActiveBookings,
    setDisplayCurrency,
  };
};

export default useUser;
